export default {
  Runoff: "rf_",
  Indundation: "in_",
};
